import React, { PureComponent } from "react";

import Select from "react-select";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";

import sparklesImg from "images/sparkles.svg";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import styles from "./style.module.css";

export default class ProjectTitle extends React.PureComponent {
  render() {
    const { title, isLoading, children, isDark, className, ...retProps } = this.props;
    return (
      <div
        className={
          styles.projectTitleWrapper + " " + (isDark ? styles.isDark : "") + " " + (className ? className : "")
        }
        {...retProps}
      >
        <div className={styles.projectTitleHeader}>
          <div className={styles.projectTitleIcon}>
            {isLoading ? (
              <LoadingIndicator
                style={{ width: "20px", height: "20px", transform: "scale(0.30)", margin: "-8px 0px 0px -6px" }}
              />
            ) : (
              <Icon src={sparklesImg} size={20} />
            )}
          </div>
          <div className={styles.projectTitle}>{title}</div>
        </div>
        <div className={styles.projectSubtitle}>{children}</div>
      </div>
    );
  }
}
